import React, { useId } from 'react';

interface LogoProps {
  className?: string;
  title?: string;
}

const Logo: React.FC<LogoProps> = ({ className, title = 'PHI Printing Logo' }) => {
  const gradientId = useId();

  return (
    <svg
      className={className}
      viewBox="0 0 224 520"
      role="img"
      aria-label={title}
    >
      <defs>
        <linearGradient
          id={`${gradientId}-gradient`}
          x1="0"
          y1="0"
          x2="0"
          y2="520"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="var(--logo-gradient-start)" />
          <stop offset="100%" stopColor="var(--logo-gradient-end)" />
        </linearGradient>
      </defs>
      <g
        fill="none"
        stroke={`url(#${gradientId}-gradient)`}
        strokeLinecap="round"
        strokeLinejoin="round"
        shapeRendering="geometricPrecision"
      >
        <circle cx="112" cy="260" r="96" strokeWidth="24" />
        <line x1="112" y1="0" x2="112" y2="520" strokeWidth="24" />
      </g>
    </svg>
  );
};

export default Logo;
